export default "__VITE_ASSET__DF_a5VsW__"